import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { FC, useEffect } from 'react';

export interface IAnimTextProps {
  text: string;
  delay: number;
  duration?: number;
  className?: string;
}

const TextTypeAnimation: FC<IAnimTextProps> = ({ delay, text, duration, ...props }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const displayText = useTransform(rounded, (latest) => text.slice(0, latest));

  useEffect(() => {
    const controls = animate(count, text.length, {
      type: 'tween',
      delay: delay,
      duration: duration || 1,
      ease: 'easeInOut',
    });
    return controls.stop;
  }, []);

  return <motion.span {...props}>{displayText}</motion.span>;
};

export default TextTypeAnimation;
